/* Verolae · LP Reviews — carousel behaviour.
   Port of the GemPages carousel (gp-carousel-v7-5.js, keen-slider based) used by the review section on the source site landing pages, rebuilt on the theme-wide Swiper 11 (window.Swiper, loaded in layout/theme.liquid).
   Source settings reproduced: 4 / 3 / 1 slides per view (desktop / tablet <= 1024px / mobile <= 767px),
   30px / 30px / 18px gaps, loop, drag, 500ms ease-in transition, prev/next arrows, dots on mobile only
   (rendered here, as the source renders them by JS), optional autoplay with pause on hover.
   Swiper's loop needs at least 2 x slidesPerView slides while the keen-slider loop does not, so the original
   slides are cloned (marked data-verolae-clone) until there are enough; dots and the editor's block-select
   always map back to the original review index. Scoped per instance via data-section-id; theme-editor aware. */
(function () {
  'use strict';

  var ROOT_SELECTOR = '.verolae-lp-reviews[data-section-id]';
  var instances = {};

  function toInt(value, fallback) {
    var n = parseInt(value, 10);
    return isNaN(n) ? fallback : n;
  }

  function isTrue(value) {
    return value === 'true' || value === '1' || value === true;
  }

  function removeClones(wrapper) {
    Array.prototype.slice.call(wrapper.querySelectorAll('[data-verolae-clone]')).forEach(function (clone) {
      clone.parentNode.removeChild(clone);
    });
  }

  function create(root) {
    var id = root.getAttribute('data-section-id');
    if (!id || instances[id]) return;

    var sliderEl = root.querySelector('.gem-slider');
    var wrapper = sliderEl ? sliderEl.querySelector('.swiper-wrapper') : null;
    if (!sliderEl || !wrapper || typeof window.Swiper !== 'function') return;

    var prevBtn = root.querySelector('.gp-carousel-action-back');
    var nextBtn = root.querySelector('.gp-carousel-action-next');
    var dotsWrap = root.querySelector('.gp-carousel-dot-container');

    var pvDesktop = Math.max(1, toInt(root.getAttribute('data-slides-desktop'), 4));
    var pvTablet = Math.max(1, toInt(root.getAttribute('data-slides-tablet'), 3));
    var pvMobile = Math.max(1, toInt(root.getAttribute('data-slides-mobile'), 1));
    var gap = Math.max(0, toInt(root.getAttribute('data-gap'), 30));
    var gapMobile = Math.max(0, toInt(root.getAttribute('data-gap-mobile'), 18));
    var speed = Math.max(0, toInt(root.getAttribute('data-speed'), 500));
    var loop = isTrue(root.getAttribute('data-loop'));
    var autoplay = isTrue(root.getAttribute('data-autoplay'));
    var delay = Math.max(1, toInt(root.getAttribute('data-autoplay-delay'), 2)) * 1000;

    // Start from the original (non-clone) slides. A theme-editor reload hands us a fresh DOM,
    // but strip leftovers defensively.
    removeClones(wrapper);
    var originals = Array.prototype.slice.call(wrapper.children);
    var count = originals.length;
    if (count <= 1) loop = false;

    // Swiper loop mode needs >= 2 x slidesPerView slides to stay seamless; clone whole rounds of the
    // original slides until the largest breakpoint is covered (the source's keen-slider loop has no such limit).
    if (loop) {
      var needed = Math.max(pvDesktop, pvTablet, pvMobile) * 2;
      var rounds = 0;
      while (wrapper.children.length < needed && rounds < 10) {
        originals.forEach(function (slide) {
          var clone = slide.cloneNode(true);
          clone.setAttribute('data-verolae-clone', 'true');
          clone.setAttribute('aria-hidden', 'true');
          clone.removeAttribute('data-shopify-editor-block');
          wrapper.appendChild(clone);
        });
        rounds++;
      }
    }

    var swiper = null;
    var dots = [];

    function goTo(index) {
      if (!swiper || count === 0) return;
      var target = ((index % count) + count) % count;
      if (loop) {
        swiper.slideToLoop(target);
      } else {
        swiper.slideTo(target);
      }
    }

    function buildDots() {
      if (!dotsWrap) return;
      dotsWrap.innerHTML = '';
      dots = [];
      if (count <= 1) return;
      for (var i = 0; i < count; i++) {
        var dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'gp-carousel-dot';
        dot.setAttribute('role', 'tab');
        dot.setAttribute('aria-label', 'Go to slide ' + (i + 1));
        dot.setAttribute('aria-selected', i === 0 ? 'true' : 'false');
        dot.setAttribute('data-index', String(i));
        dot.addEventListener('click', function () {
          goTo(toInt(this.getAttribute('data-index'), 0));
        });
        dotsWrap.appendChild(dot);
        dots.push(dot);
      }
    }

    function syncDots(instance) {
      if (!dots.length || !instance) return;
      var active = (((instance.realIndex || 0) % count) + count) % count;
      dots.forEach(function (dot, i) {
        var on = i === active;
        dot.classList.toggle('is-active', on);
        dot.setAttribute('aria-selected', on ? 'true' : 'false');
      });
    }

    buildDots();

    var options = {
      slidesPerView: pvMobile,
      spaceBetween: gapMobile,
      slidesPerGroup: 1,
      speed: speed,
      loop: loop,
      grabCursor: true,
      simulateTouch: true,
      watchOverflow: true,
      navigation: {
        prevEl: prevBtn || null,
        nextEl: nextBtn || null
      },
      breakpoints: {
        768: { slidesPerView: pvTablet, spaceBetween: gap },
        1025: { slidesPerView: pvDesktop, spaceBetween: gap }
      },
      on: {
        afterInit: function (instance) { syncDots(instance); },
        slideChange: function (instance) { syncDots(instance); }
      }
    };
    if (autoplay) {
      options.autoplay = {
        delay: delay,
        pauseOnMouseEnter: true,
        disableOnInteraction: false
      };
    }

    swiper = new window.Swiper(sliderEl, options);
    syncDots(swiper);

    instances[id] = {
      swiper: swiper,
      goTo: goTo,
      destroy: function () {
        try { swiper.destroy(true, true); } catch (e) { /* noop */ }
        removeClones(wrapper);
        if (dotsWrap) dotsWrap.innerHTML = '';
        delete instances[id];
      }
    };
  }

  function initAll() {
    document.querySelectorAll(ROOT_SELECTOR).forEach(create);
  }

  // Swiper is loaded with defer in theme.liquid ahead of this file, but wait for it if it is still on its way.
  function whenSwiperReady(callback, attempt) {
    if (typeof window.Swiper === 'function') { callback(); return; }
    attempt = attempt || 0;
    if (attempt > 100) return;
    setTimeout(function () { whenSwiperReady(callback, attempt + 1); }, 50);
  }

  function boot() {
    whenSwiperReady(initAll);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  // Shopify theme editor events
  if (window.Shopify && window.Shopify.designMode) {
    document.addEventListener('shopify:section:load', function (event) {
      var root = event.target.querySelector(ROOT_SELECTOR);
      if (!root) return;
      var id = root.getAttribute('data-section-id');
      if (instances[id]) instances[id].destroy();
      whenSwiperReady(function () { create(root); });
    });
    document.addEventListener('shopify:section:unload', function (event) {
      var id = event.detail && event.detail.sectionId;
      if (id && instances[id]) instances[id].destroy();
    });
    document.addEventListener('shopify:block:select', function (event) {
      var slide = event.target.closest('.gem-slider-item');
      var root = event.target.closest(ROOT_SELECTOR);
      if (!slide || !root) return;
      var instance = instances[root.getAttribute('data-section-id')];
      var index = toInt(slide.getAttribute('data-index'), NaN);
      if (!instance || isNaN(index)) return;
      if (instance.swiper && instance.swiper.autoplay && instance.swiper.autoplay.running) {
        instance.swiper.autoplay.stop();
      }
      instance.goTo(index);
    });
  }
})();
